<button class="fab-button"
        [title]="title"
        [style.backgroundColor]="color"
        (click)="onClick()">
  <span class="{{ icon }}"></span>
</button>
